import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Button, Row, Col, Spinner } from 'react-bootstrap';
import { InputField, TextAreaField } from "../../../lib/formControls";

const schema = yup.object().shape({
  bunkName: yup.string().required('Petrol Bunk Name is required'),
  bunkAddress1: yup.string().required('Street Address is required'),
  bunkAddress2: yup.string().required('Locality/Area is required'),
  bunkDistrict: yup.string().required('District is required'),
  bunkState: yup.string().required('State is required'),
  bunkPinCode: yup
    .string()
    .required('PIN Code is required')
    .matches(/^\d{6}$/, 'PIN Code must be exactly 6 digits(number)')
});


const BunkForm = ({ mode = 'add', onSubmit, handleAction, initialData = {}, bunkSavedFormData = {}, loading=false }) => {
  const {
  register,
  handleSubmit,
  reset,
  watch,
  setValue,
  control,
  formState: { errors, isSubmitting }
} = useForm({
  resolver: yupResolver(schema, { context: { mode } }),
  defaultValues: {
    bunkName: '',
    bunkAddress1: '',
    bunkAddress2: '',
    bunkDistrict: '',
    bunkState: '',
    bunkPinCode: ''
  }
});

const [actiondisable, setActiondisable] = useState(true);

const watchBunkName = watch("bunkName");
const watchBunkAddress1 = watch("bunkAddress1");
const watchBunkAddress2 = watch("bunkAddress2");
const watchBunkDistrict = watch("bunkDistrict");
const watchBunkState = watch("bunkState");
const watchBunkPinCode = watch("bunkPinCode");

useEffect(() => {
  if (watchBunkName || watchBunkAddress1 || watchBunkAddress2 || watchBunkDistrict || watchBunkState || watchBunkPinCode) {
    setActiondisable(false);
  }
  if (watchBunkName === '' && watchBunkAddress1 === '' && watchBunkAddress2 === '' && watchBunkDistrict === '' && watchBunkState === '' && watchBunkPinCode === '') {
    setActiondisable(true);
  }
}, [watchBunkName, watchBunkAddress1, watchBunkAddress2, watchBunkDistrict, watchBunkState, watchBunkPinCode]);

  useEffect(() => {
    /*if (mode === 'edit' && initialData) {*/
    if (bunkSavedFormData) {  
      Object.keys(bunkSavedFormData).forEach((key) => {
        if(key !== 'id') {
           setValue(key, bunkSavedFormData[key]);
        }
      });
    } else if (initialData) {  
      Object.keys(initialData).forEach((key) => {
        setValue(key, initialData[key]);
      });
    }

  }, [mode, initialData, bunkSavedFormData, setValue]);

  const handleSubmitForm = (data) => {
  console.log('Submitting form data:', data);
  onSubmit(data);
};

  return (
    <form className='d-flex flex-column petrolbunk-commonfromcls bunk-from-main' onSubmit={handleSubmit(handleSubmitForm)}>

      <div className='form-header-main'>
          <div className='form-header-row'>
              <div className='form-header-text'> <h6>Bunk Details (1/3)</h6> </div>
              <div className='form-header-icon'> <button type="button" onClick={() => handleAction('close-form')} className="btn-close position-absolute end-0 top-0 m-3"></button> </div>
          </div>
      </div>

      <Row>
        <Col md={12}>
          <InputField
            label="Petrol Bunk Name"
            name="bunkName"
            type="text"
            placeholder="Petrol Bunk Name"
            controlclass="form-custom-group"
            required={true}
            register={register}
            className="custom-input-pd"
            errors={errors}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <InputField
            label="Street Address"
            name="bunkAddress1"
            type="text"
            placeholder="Street Address"
            controlclass="form-custom-group"
            required={true}
            register={register}
            className="custom-input-pd"
            errors={errors}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <InputField
            label="Locality/Area"
            name="bunkAddress2"
            type="text"
            placeholder="Locality/Area"
            controlclass="form-custom-group"
            required={true}
            register={register}
            className="custom-input-pd"
            errors={errors}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <InputField
            label="District"
            name="bunkDistrict"
            type="text"
            placeholder="District"
            controlclass="form-custom-group"
            required={true}
            register={register}
            className="custom-input-pd"
            errors={errors}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <InputField
            label="State"
            name="bunkState"
            type="text"
            placeholder="State"
            controlclass="form-custom-group"
            required={true}
            register={register}
            className="custom-input-pd"
            errors={errors}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <InputField
            label="PIN Code"
            name="bunkPinCode"
            type="text"
            placeholder="PIN Code"
            controlclass="form-custom-group"
            required={true}
            register={register}
            className="custom-input-pd"
            errors={errors}
          />
        </Col>
      </Row>


      <div className="col-md-12 d-flex justify-content-between mt-auto pt-2 action-btn-buttomdiv">
        <Button variant="secondary custom-cnl-btncls" disabled={actiondisable || isSubmitting || loading} type="button" onClick={() => reset()}>
          Reset
        </Button>
        <Button type="submit" disabled={actiondisable || isSubmitting || loading} variant="primary custom-sbm-btncls">
          {loading ? (
            <>
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
              {' '}{mode === 'edit' ? 'Updating bunk...' : 'Adding bunk...'}
            </>
          ) : (
            mode === 'edit' ? 'Next' : 'Next'
          )}
        </Button>
      </div>
    </form>
  );
};

export default BunkForm;
